import { Button, Stack } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { useFormItem } from '../../../common/hooks/use-form-item';
import { InputType } from '../../../common/hooks/use-form-item/types';
import { maxLength } from '../../../common/hooks/use-form-item/validators/operational';

type Props = {
  onSubmit: (policyDN: string) => Promise<void>;
};

export const VenafiUploadForm = ({ onSubmit }: Props) => {
  const [uploading, setUploading] = useState(false);
  const [policy, policyComponent, policyValid] = useFormItem<string>({
    type: InputType.TYPE_TEXT,
    value: '',
    label: t('venafiUploadPolicy'),
    validator: maxLength(1000),
    inputOptions: { help: t('venafiUploadPolicyHelp'), sx: { width: 'auto' } },
    textOptions: { trimOnBlur: true },
  });

  const canSubmit = !uploading && !!policy && policyValid;

  const handleSubmit = async () => {
    if (!canSubmit) return;

    setUploading(true);
    await onSubmit(policy);
    setUploading(false);
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {policyComponent}
      <Button variant="contained" onClick={handleSubmit} disabled={!canSubmit}>
        {t('venafiUpload')}
      </Button>
    </Stack>
  );
};
